import * as THREE from "three"
import { useFrame } from "@react-three/fiber"
import { useRef, Suspense } from "react"
import useStore from "../AppStore"
import Planet from "../3d/Planet"

export default function ScenePlanet(props) {
  
  const groupRef = useRef(null)
  const planetRef = useRef(null)
  
  useFrame(({clock}) => {
    const top = useStore.getState().top
    planetRef.current.rotation.y = 0.5-top * 0.001 //- clock.elapsedTime * 0.1
  })
  
  return(
    <group ref={groupRef} {...props}>
      <Planet ref={planetRef} />
    </group>
  )
}

